<template>
  <div id="app">
    <ljb-loading
      v-if="isLoading"/>
    <div
      v-else
      class="base">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
        <!-- <div>12321321</div> -->
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
      <ljb-login/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import LjbLogin from '@/components/common/LjbLogin'
import Request from '@/libs/request/http'

let isInited = false
export default {
  name: 'App',
  components: {LjbLogin},
  data () {
    return {
      isCheck: true,
      isLoading: true
    }
  },
  computed: {
    ...mapGetters('Channel', ['getChannelData']),
    ...mapGetters('User', ['getUserInfo'])
    // isLoading () {
    //   if (this.isCheck) {
    //     if (this.$utils.isEmpty(this.getChannelData)) return true
    //     if (this.$utils.getChannel() !== this.getChannelData.channelCode) {
    //       return true
    //     }
    //   }
    //   return false
    // }
  },
  created () {
    this.isLoading = true
    this.$store.dispatch('Channel/getChannel')
    let urlParams = this.$utils.urlParams()
    console.log(urlParams, 'urlParams')
    if (urlParams && urlParams.token) {
      this.$store.commit('User/setUserInfo', { token: urlParams.token })
      localStorage.setItem('token', urlParams.token)
      // this.getInfo(token)
    } else {
      var rou = ''
      if (window.location.href.indexOf('/?/') > -1) {
        console.log(1232321321321, '/?/')
        var url = window.location.href.split('/?/')[1]
        if (url.indexOf('#/') > -1) {
          console.log('#/', url.split('#/')[0])
          rou = '/'+url.split('#/')[0]
        }
      } else {
        rou = location.hash
        if (rou) {
          rou = rou.replace('#', '')
        }
      }
      // console.log(rou, 'rou')
      if (this.$utils.isWxgzh() && !isInited) {
        this.isCheck = false
        if (urlParams && urlParams.code) {
          this.$store.dispatch('User/requestOpenId', {code: urlParams.code, token: urlParams.token})
          this.isCheck = true
          return
        }
        // let rou = location.hash
        // if (rou) {
        //   rou = rou.replace('#', '')
        // }
        // console.log(rou, 'approu')
        location.href = this.$api.REDIRECT_OPENID + '?callback=' + decodeURIComponent(location.origin + location.pathname) + '&router=' + decodeURIComponent(rou)
        isInited = true
      }
    }
  },
  mounted: function () {
    this.$utils.wxShare()
    setTimeout(() => {
      this.isLoading = false
    }, 1000)
  },
  methods: {
    check () {
      this.isShowAlert = true
    },
    // async getInfo(token) {
    //   const userInfo = await Request.get('user/userInfo', null, { headers: { token: token } })
    //   console.log(userInfo, ', null, { headers: { token: params.authorizationToken } }')
    // }
  },
  watch: {
    $route(to) {
      console.log(to)
      if (to.name === 'LawAndPrivate' || to.name === 'LawyerForInfo') {
        console.log('缓存了')
        this.$utils.updateShareData(to.path)
      } else {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        this.$utils.updateShareData(to.path)
      }
    }
  },
}
</script>

<style type="text/css" lang="scss">
  #app {
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    height: 100%;
    background: $background-color;
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #ccc;
    font-size: 14px;
  }

  input:-moz-placeholder, textarea:-moz-placeholder {
    color: #ccc;
    font-size: 14px;
  }

  input::-moz-placeholder, textarea::-moz-placeholder {
    color: #ccc;
    font-size: 14px;
  }

  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    color: #ccc;
    font-size: 14px;
  }
  html,body,#app{
    // height: auto;
    min-height: 100%;
    overflow-x: hidden;
  }
  .base{
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    height: 100%;
  }
  li{
    list-style-type: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue